(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["eb-client-experiences"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sections = document.querySelectorAll(
      '[data-eb-client-experiences]'
    );

    sections.forEach((section) => {
      if (section.dataset.ebReady === 'true') return;

      section.dataset.ebReady = 'true';

      const button = section.querySelector(
        '[data-eb-reviews-toggle]'
      );

      const archive = section.querySelector(
        '[data-eb-reviews-archive]'
      );

      const label = section.querySelector(
        '[data-eb-reviews-toggle-label]'
      );

      if (!button || !archive || !label) return;

      const applyState = (open) => {
        button.setAttribute('aria-expanded', String(open));
        archive.hidden = !open;

        label.textContent = open
          ? button.dataset.closeLabel
          : button.dataset.openLabel;

        if (open) {
          requestAnimationFrame(() => {
            archive.scrollIntoView({
              behavior: 'smooth',
              block: 'start'
            });
          });
        }
      };

      button.addEventListener('click', () => {
        const open =
          button.getAttribute('aria-expanded') !== 'true';

        if (document.startViewTransition) {
          document.startViewTransition(() => {
            applyState(open);
          });
        } else {
          applyState(open);
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eb-size-guide"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const weights = [0.30, 0.50, 0.75, 1.00, 1.25, 1.50, 1.75, 2.00, 2.50, 3.00, 4.00, 5.00];
    const shapes = {
      round: { name: 'Round', width: 6.5 },
      oval: { name: 'Oval', length: 8.0, width: 5.5 },
      emerald: { name: 'Emerald Cut', length: 7.0, width: 5.0 },
      pear: { name: 'Pear Shape', length: 8.5, width: 5.5 },
      cushion: { name: 'Long Cushion', length: 7.2, width: 5.1 },
      princess: { name: 'Princess Cut', length: 5.5, width: 5.5 },
      radiant: { name: 'Radiant Cut', length: 7.0, width: 5.0 },
      marquise: { name: 'Marquise Shape', length: 10.5, width: 5.0 }
    };
    function initialise(root) {
      if (root.dataset.ebReady) return;
      root.dataset.ebReady = 'true';
      const tabs = [...root.querySelectorAll('[data-eb-tab]')];
      const panels = [...root.querySelectorAll('[data-eb-panel]')];
      function selectTab(tab, focus) {
        tabs.forEach(item => {
          const active = item === tab;
          item.setAttribute('aria-selected', String(active));
          item.tabIndex = active ? 0 : -1;
        });
        panels.forEach(panel => { panel.hidden = panel.dataset.ebPanel !== tab.dataset.ebTab; });
        if (focus) tab.focus();
      }
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => selectTab(tab, false));
        tab.addEventListener('keydown', event => {
          let next = index;
          if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
          else if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
          else if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = tabs.length - 1;
          else return;
          event.preventDefault();
          selectTab(tabs[next], true);
        });
      });
      const picker = root.querySelector('[data-eb-shape]');
      const body = root.querySelector('[data-eb-diamond-body]');
      const caption = root.querySelector('[data-eb-diamond-caption]');
      function renderDiamonds() {
        const shape = shapes[picker.value];
        caption.textContent = `Approximate ${shape.name} diamond dimensions by carat weight`;
        body.replaceChildren(...weights.map(weight => {
          const scale = Math.cbrt(weight);
          const size = shape.length
            ? `${(shape.length * scale).toFixed(1)} × ${(shape.width * scale).toFixed(1)} mm`
            : `${(shape.width * scale).toFixed(1)} mm diameter`;
          const row = document.createElement('tr');
          const heading = document.createElement('th');
          const value = document.createElement('td');
          heading.scope = 'row';
          heading.textContent = `${weight.toFixed(2)} ct`;
          value.textContent = size;
          row.append(heading, value);
          return row;
        }));
      }
      picker.addEventListener('change', renderDiamonds);
      renderDiamonds();
    }
    function initialiseAll(context) {
      context.querySelectorAll('.eb-size').forEach(initialise);
    }
    initialiseAll(document);
    document.addEventListener('shopify:section:load', event => initialiseAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
